/* istanbul ignore file */
import listeners from './listeners';
import rootReducer from './rootReducer';
import { initStoreListeners } from './initStoreListeners';
import { configureStore } from '@reduxjs/toolkit';
export default (function () {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var listenerMiddleware = initStoreListeners(listeners);
  var store = configureStore({
    reducer: rootReducer,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['Payment/LOAD_MOP']
        }
      }).prepend(listenerMiddleware.middleware);
    },
    preloadedState: initialState
  });
  return store;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/store.js
// module id = 4370
// module chunks = 11